import { FileLogger } from "./file.logger";

/**
 * Creates a logger with each run of a process, with timestamp as filename
 */
class RunLogger extends FileLogger {
	constructor(prefix: string, normalDebug: boolean, fileLocation: string) {
		const currentTime = new Date();
		const dayStamp = currentTime.toISOString().split("T")[0];
		const timeStamp = currentTime.toTimeString().split(" ")[0].split(":").join("-");
		const fileName = `${dayStamp}-${timeStamp}`;
		super(fileName, prefix, normalDebug, fileLocation);
	}
}

/**
 * Function that returns a logger to specified folder, and filename equal to current timestamp format
 * @param {string} prefix prefix for all logs to start with
 * @param {boolean} normalDebug wether to write logs using normal debug module as well as file
 * @param {string} fileLocation log file location insied ./log
 * @returns {RunLogger}
 */
export const runLogger = (prefix: string, normalDebug = false, fileLocation: string = FileLogger.DEFAULT_RELATIVE_FILE_LOCATION): RunLogger => new RunLogger(prefix, normalDebug, fileLocation);
